import { restoreVariableCase } from './urlParams';

/**
 * Readable default request title from a URL (hostname + path + query).
 */
export function deriveRequestNameFromUrl(raw) {
  const s = (raw || '').trim();
  if (!s) return '';

  const tryParse = (candidate) => {
    try {
      return new URL(candidate);
    } catch {
      return null;
    }
  };

  let u = tryParse(s);
  if (!u && !/^https?:\/\//i.test(s)) {
    u = tryParse(`https://${s}`);
  }
  if (u) {
    // new URL() percent-encodes {{variable}} braces in the pathname and lowercases them
    // in the hostname — undo both so the derived name shows the placeholder as typed.
    const pathname = u.pathname.replace(/%7B/gi, '{').replace(/%7D/gi, '}');
    const path = pathname === '/' ? '' : pathname;
    let out = restoreVariableCase(`${u.hostname}${path}${u.search || ''}`, s);
    if (out.length > 200) out = `${out.slice(0, 197)}...`;
    return out;
  }

  let out = s.replace(/\s+/g, ' ');
  if (out.length > 200) out = `${out.slice(0, 197)}...`;
  return out;
}

/** Names a new tab starts with — placeholders, not something the user chose. */
const PLACEHOLDER_NAMES = new Set(['New Request', 'New GraphQL query']);

export function isUnsetRequestName(name) {
  const n = (name ?? '').trim();
  return n === '' || PLACEHOLDER_NAMES.has(n);
}

/**
 * Name to persist when saving: custom name wins; otherwise URL-derived; last resort "New Request".
 */
export function resolvedRequestName(name, url) {
  const trimmed = (name ?? '').trim();
  if (trimmed && !PLACEHOLDER_NAMES.has(trimmed)) return trimmed;
  const fromUrl = deriveRequestNameFromUrl(url);
  if (fromUrl) return fromUrl;
  return trimmed || 'New Request';
}
